module.exports = __webpack_public_path__ + "img/timeline_mainevent-6.6036900f.jpg";